module.exports = __webpack_public_path__ + "assets/img/icon1.ea2a3b79.png";